import React from 'react';

const StarField: React.FC = () => (
  <div className="star-field fixed inset-0 z-0" aria-hidden="true">
    <div className="absolute inset-0 bg-mystical-gradient" />
    <div
      className="absolute inset-0 opacity-70"
      style={{
        backgroundImage: [
          'radial-gradient(circle at 18% 14%, rgba(201,166,107,0.08), transparent 24%)',
          'radial-gradient(circle at 84% 22%, rgba(79,85,126,0.12), transparent 28%)',
          'radial-gradient(circle at 50% 100%, rgba(31,42,68,0.22), transparent 42%)',
          'radial-gradient(rgba(244,239,227,0.22) 0.6px, transparent 0.8px)',
        ].join(', '),
        backgroundSize: 'auto, auto, auto, 46px 46px',
      }}
    />
  </div>
);

export default StarField;
